import GameTesting from '../../Firestore/GameTesting.js'

class RecordingComponent {
  constructor() {
    this.screenMediaRecorder = null;
    this.webcamMediaRecorder = null;
    this.streamRecordedChunks = [];
    this.webcamRecordedChunks = [];
    this.isWebcamVisible = false;
    this.webcamStream = null;
    this.screenStream = null;
    this.error = null;
    this.mic_error = null;
    this.constraints = {
      audio: false,
      video: false, // Video is initially disabled
    };
    this.recordingStartTime = null;
    this.recordingEndTime = null;
    this.transcript = "";
    this.transcriptFinal = "";
    this.isManuallyStopped = false;
    this.audioStartTime = null;
    this.timestamps = [];
  }

  async startRecording() {
    try {
      // Request screen capture
      let screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: { cursor: 'always' },
        audio: true,
      });
      this.screenStream = screenStream;
      this.constraints.audio = false;
      this.constraints.video = false;

      // Request webcam and audio
      await this.toggleWebcam();
      await this.getMic();
      // Marks when the recording started
      this.recordingStartTime = Date.now();
      this.audioStartTime = Date.now();

      /* Screen sharing checks */

      // Create audio stream using mic and sounds from screen being shared
      let source1 = null;
      let source2 = null;
      const context = new AudioContext();
      const combinedAudio = context.createMediaStreamDestination();
      if (this.screenStream.getAudioTracks().length > 0) {
        source1 = context.createMediaStreamSource(this.screenStream);
        source1.connect(combinedAudio);
      }
      if (this.webcamStream && this.webcamStream.getAudioTracks().length > 0) {
        source2 = context.createMediaStreamSource(this.webcamStream);
        source2.connect(combinedAudio);
      }

      // Combine video and audio
      let screenRecordStream = null;
      if (this.screenStream.getAudioTracks().length > 0 || (this.webcamStream && this.webcamStream.getAudioTracks().length > 0)) {
        screenRecordStream = new MediaStream([...this.screenStream.getVideoTracks(), ...combinedAudio.stream.getAudioTracks()]);
      }
      else {
        screenRecordStream = new MediaStream([...this.screenStream.getVideoTracks()]);
      }

      let webcamStream = null;
      if (this.webcamStream && this.webcamStream.getVideoTracks().length > 0 && this.webcamStream.getAudioTracks().length > 0) { // Has webcam and mic
        webcamStream = new MediaStream([...this.webcamStream.getVideoTracks(), ...this.webcamStream.getAudioTracks()]);
      }
      else if (this.webcamStream && this.webcamStream.getVideoTracks().length > 0) { // Has only webcam
        webcamStream = new MediaStream([...this.webcamStream.getVideoTracks()]);
      }
      else if (this.webcamStream && this.webcamStream.getAudioTracks().length > 0) { // Has only audio
        webcamStream = new MediaStream([...this.webcamStream.getAudioTracks()]);
      }

      // If there is webcam/mic audio, do it
      if (webcamStream) {
        this.webcamMediaRecorder = new MediaRecorder(webcamStream);
        this.webcamMediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.webcamRecordedChunks.push(event.data);
          }
        };
        this.webcamMediaRecorder.start();
      }


      // Initialize MediaRecorder
      this.screenMediaRecorder = new MediaRecorder(screenRecordStream);

      // Collect recorded data chunks
      this.screenMediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.streamRecordedChunks.push(event.data);
        }
      };

      this.screenMediaRecorder.start();

      if (this.webcamStream && this.webcamStream.getAudioTracks().length > 0) {
        this.speechRecognition.start();
      }

      // Track whether the user ends screen recording early
      this.screenStream.getTracks().forEach(track => {
        track.onended = () => {
          console.log("Screen sharing ended early by the user.");
          this.handleAbruptScreenShareEnd();
        };
      });
    } catch (error) {
      console.error('Error starting recording:', error);
      throw error;
    }
  }
  stopRecording() {
    this.recordingEndTime = Date.now();
    return new Promise((resolve) => {
      if (this.screenMediaRecorder && this.screenMediaRecorder.state !== 'inactive') {
        let screenBlob, webcamBlob;

        const checkAndResolve = () => {
          if (screenBlob && webcamBlob) {
            // Only generate webcam blob if there is a webcam recording
            if (this.webcamStream.getVideoTracks().length > 0) {
              resolve({ screenBlob, webcamBlob });
            }
            else {
              resolve({ screenBlob });
            }

            // Stop receiving input
            this.webcamStream.getTracks().forEach(track => track.stop());
            this.screenStream.getTracks().forEach(track => track.stop());

            this.screenMediaRecorder = null;
            this.webcamMediaRecorder = null;
            this.webcamStream = null;
            this.screenStream = null;
            this.streamRecordedChunks = [];
            this.webcamRecordedChunks = [];
          }
          else if (screenBlob && this.webcamStream === null) {
            resolve({ screenBlob });

            // Stop receiving input
            this.screenStream.getTracks().forEach(track => track.stop());

            this.screenMediaRecorder = null;
            this.webcamMediaRecorder = null;
            this.webcamStream = null;
            this.screenStream = null;
            this.streamRecordedChunks = [];
            this.webcamRecordedChunks = [];
          }
        }
        // Stop recordings
        if (this.screenMediaRecorder) {
          this.screenMediaRecorder.onstop = () => {
            screenBlob = new Blob(this.streamRecordedChunks, { type: 'video/mp4' });
            checkAndResolve();
          };
          this.screenMediaRecorder.stop();
        }
        if (this.webcamMediaRecorder) {
          this.webcamMediaRecorder.onstop = () => {
            webcamBlob = new Blob(this.webcamRecordedChunks, { type: 'video/mp4' });
            checkAndResolve();
          }
          this.webcamMediaRecorder.stop();
        }

        // Stop tracks
        if (this.webcamStream) {
          this.webcamStream.getTracks().forEach(track => track.stop());
        }
        if (this.screenStream) {
          this.screenStream.getTracks().forEach(track => track.stop());
        }
      } else {
        resolve(null);
      }

      // Stop speech recognition
      if (this.speechRecognition) {
        this.isManuallyStopped = true;
        this.speechRecognition.stop();
        this.speechRecognition = null;
        this.transcriptFinal = this.transcript;
        this.transcript = "";
        this.audioStartTime = null;
        this.timestamps = [];
      }
    });
  }
  async toggleWebcam() {
    try {
      const cameraPermission = await navigator.permissions.query({ name: "camera" });

      if (!this.isWebcamVisible && cameraPermission.state === "granted") {
        this.isWebcamVisible = true;
        this.constraints.video = true;
        this.webcamStream = await navigator.mediaDevices.getUserMedia(this.constraints);
        if (this.$refs) {
          this.$refs.videoElement.srcObject = this.webcamStream;
        }
      } else if (this.isWebcamVisible && cameraPermission.state === "granted" || this.isWebcamVisible && cameraPermission.state === "denied") {
        this.webcamStream.getTracks().forEach((track) => track.stop());
        this.webcamStream = null;
        this.isWebcamVisible = false;
      }
    } catch (err) {
      this.error = "User denied access";
      console.error(err);
    }
  }
  async getMic() {
    try {
      const microphonePermission = await navigator.permissions.query({ name: "microphone" });

      if (microphonePermission.state === "denied") {
        this.mic_error = "User denied access";
        this.constraints.audio = false;
      } else {
        if (this.webcamStream) {
          this.webcamStream.getTracks().forEach((track) => track.stop());
        }

        // Update constraints
        this.constraints.audio = true;
        this.startSpeechRecognition();
        this.webcamStream = await navigator.mediaDevices.getUserMedia(this.constraints);
        this.mic_error = null; // Clear any previous errors
      }

    } catch (err) {
      this.mic_error = "Cannot find user device";
      this.constraints.audio = false;
      console.error(err);
    }
  }
  startSpeechRecognition() {
    // Create Speech Recognition
    this.speechRecognition = new webkitSpeechRecognition();
    this.speechRecognition.continuous = true;
    this.speechRecognition.interimResults = false;
    this.speechRecognition.lang = 'en-US';

    this.speechRecognition.onresult = (event) => {
      let tempTranscript = "";
      for (let i = 0; i < event.results.length; i++) {
        if (event.results.length > this.timestamps.length) {
          this.timestamps.push(new Date(Date.now() - this.audioStartTime).toISOString().slice(12, 19));
        }
        tempTranscript = this.timestamps[i] + ' ' + event.results[i][0].transcript + ' ';
      }
      tempTranscript += ';';
      this.transcript += tempTranscript;
    };
    this.speechRecognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
    };
    this.speechRecognition.onend = () => {
      // Restart speech recognition if it ends abruptly
      if (!this.isManuallyStopped) {
        this.timestamps = [];
        console.log("Speech recognition stopped unexpectedly. Restarting...");
        this.startSpeechRecognition();
      }
    };

    this.isManuallyStopped = false;
  }
  getRecordingDuration() {
    if (this.recordingStartTime && this.recordingEndTime) {
      return (this.recordingEndTime - this.recordingStartTime - 80)/ 1000; // Duration in seconds
    }
    return 0;
  }
  handleAbruptScreenShareEnd() {
    // How do we want to handle error?
  }
}

export default RecordingComponent;



// WEBPACK FOOTER //
// ./src/components/playtest/Recording.js